/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signing_InInputs */

const en_auth_signing_in = /** @type {(inputs: Auth_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing in...`)
};

const de_auth_signing_in = /** @type {(inputs: Auth_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmeldung...`)
};

const fr_auth_signing_in = /** @type {(inputs: Auth_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion en cours...`)
};

const es_auth_signing_in = /** @type {(inputs: Auth_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando sesión...`)
};

const it_auth_signing_in = /** @type {(inputs: Auth_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso in corso...`)
};

const nl_auth_signing_in = /** @type {(inputs: Auth_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen...`)
};

const pl_auth_signing_in = /** @type {(inputs: Auth_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logowanie...`)
};

const fi_auth_signing_in = /** @type {(inputs: Auth_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudutaan...`)
};

const da_auth_signing_in = /** @type {(inputs: Auth_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logger ind...`)
};

const sv_auth_signing_in = /** @type {(inputs: Auth_Signing_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loggar in...`)
};

/**
* | output |
* | --- |
* | "Signing in..." |
*
* @param {Auth_Signing_InInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_signing_in = /** @type {((inputs?: Auth_Signing_InInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signing_InInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_signing_in(inputs)
	if (locale === "fr") return fr_auth_signing_in(inputs)
	if (locale === "es") return es_auth_signing_in(inputs)
	if (locale === "it") return it_auth_signing_in(inputs)
	if (locale === "nl") return nl_auth_signing_in(inputs)
	if (locale === "pl") return pl_auth_signing_in(inputs)
	if (locale === "fi") return fi_auth_signing_in(inputs)
	if (locale === "da") return da_auth_signing_in(inputs)
	if (locale === "sv") return sv_auth_signing_in(inputs)
	return en_auth_signing_in(inputs)
});